/**
* Created by lobin on 2020/7/14.
*/
<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
      <a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.nickname" placeholder="输入微信昵称" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.mobile" placeholder="输入电话" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-range-picker
					valueFormat="YYYY-MM-DD"
					v-model="searchRange"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
			:loading="listloading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 500 }"
			:pagination="pager"
			@change="change">
			<span slot="user" slot-scope="text, record">
          <a-avatar :src="record.headimgurl" />
          <span style="margin-left: 10px">{{ record.nickname }}</span>
			</span>
			<span slot="subscribe" slot-scope="text">
				<a-tag color="#87d068" v-if="text === 1">已关注</a-tag>
				<a-tag color="#f50" v-else>未关注</a-tag>
			</span>
      <span slot="subscribe_scene" slot-scope="text">
				<a-tag color="#87d068" v-if="text === 'ADD_SCENE_QR_CODE'">扫码</a-tag>
				<a-tag color="#f50" v-else>其他</a-tag>
			</span>
			<span slot="action" slot-scope="text, record">
				<a @click="unbind(record._id)">解绑手机</a>
			</span>
		</a-table>
	</a-card>
</template>

<script type="text/babel">
import { getUserList, unbinMobile } from '@/api/user';

export default {
  data() {
    return {
      listloading: false,
      list: [],
      pager: {},
      search: {},
      searchRange: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    columns() {
      return [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '公司',
          dataIndex: 'company.name',
          key: 'companyName',
        },
        {
          title: '站点',
          dataIndex: 'station.name',
          key: 'stationName',
        },
        {
          title: '用户',
          dataIndex: 'user.nickName',
          key: 'nickName',
          scopedSlots: { customRender: 'user' },
        },
        {
          title: '电话',
          dataIndex: 'mobile',
          key: 'mobile',
        },
        {
          title: '是否关注',
          dataIndex: 'subscribe',
          scopedSlots: { customRender: 'subscribe' },
          key: 'subscribe',
        },
        {
          title: '客户来源',
          dataIndex: 'subscribe_scene',
          key: 'subscribe_scene',
          scopedSlots: { customRender: 'subscribe_scene' },
        },
        {
          title: '时间',
          dataIndex: 'ctime',
          key: 'ctime',
        },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      width: 142,
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
  },
  methods: {
    async getList() {
      this.listloading = true;
      const q = { ...this.search };
      // eslint-disable-next-line prefer-destructuring
      q.start = this.searchRange[0];
      // eslint-disable-next-line prefer-destructuring
      q.end = this.searchRange[1];
      try {
        const { data: { docs, pager } } = await getUserList(q);
        this.list = docs;
        this.pager = {
	        ...pager,
	        showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
	  async unbind(id) {
    	await unbinMobile(id);
    	this.$message.success('操作成功');
	    this.getList();
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.user-list {

	}
</style>
